import {
    AfterViewInit,
    Component, ElementRef, HostListener, Inject, Input, Output, Renderer2, ViewChild, EventEmitter

} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
// import { environmentsActions } from '@src/store/reducers/environmentsReducer';
// import { projectsActions } from '@src/store/reducers/projectsReducer';
import { DialogManagerService } from '@src/services';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';
import { MessageDialogComponent } from '@app/shared/components/dialogs/message-dialog/message-dialog.component';




export interface LogDataTable {
    LoggedTime: string;
    Id: string;
    ComputerIP: string;
    ProcessId: string;
    ProjectName: string;
    EnvironmentName: any,
    SchemaName: string;
    LogLvl: string;
    Message: string;
}

@Component({
    selector: 'log-viewer-data',
    template: require('./log-viewer-data.component.html'),
    styles: [require('./log-viewer-data.component.scss')]
})
export class LogDataComponent implements AfterViewInit {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    public filterData: any
    public page = 1;
    private envDetail: any;
    @Input() public resetSize:boolean;
    @Output() public getLogs = new EventEmitter();
    @Output() public  flagpag = new EventEmitter();
    @Input() public isHistory: boolean = false;
    public get data() {
        return this._data;
    }


    @Input() public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((item) => {
                item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
                data.push({
                    LoggedTime: this.convertUTCtoLocal(item.LoggedTime),
                    Id: item.Id,
                    ComputerIP: item.ComputerIP,
                    ProcessId: item.ProcessId,
                    ProjectName: item.ProjectName,
                    EnvironmentName: item.EnvironmentName,
                    SchemaName: item.SchemaName,
                    LogLvl: item.LogLvl,
                    Message: item.Message,
                });
            });
            this.dataSource.data = data;
        }
    }
    // tslint:disable-next-line:variable-name
    private _data: any;

    public imageByType = {
        ERROR: 'redCircle',
        DEBUG: 'orangeCircle',
        INFO: 'greenCircle',
        WARN: 'orangeCircle'
    };

    public displayedColumns = ['LoggedTime', 'LogId', 'ComputerIP', 'ProcessId', 'ProjectName', 'EnvironmentName', 'SchemaName', 'LogLvl', 'Message'];
    public dataSource = new MatTableDataSource<LogDataTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
    private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'LoggedTime', width: 150 },
        { field: 'LogId', width: 150 },
        { field: 'ComputerIP', width: 150 },
        { field: 'ProcessId', width: 20 },
        { field: 'ProjectName', width: 150 },
        { field: 'EnvironmentName', width: 150 },
        { field: 'SchemaName', width: 150 },
        { field: 'LogLvl', width: 50 },
        { field: 'Message', width: 150 },
    ];

    constructor(
        @Inject('$stateParams') stateParams: any,
        private renderer: Renderer2,
        private dialogManagerService: DialogManagerService
    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;

    }

    convertUTCtoLocal(date) {
        if (!date)
            return;
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }


    onViewMessage(Message) {
        this.dialogManagerService.showDialog({ title: 'message', message: Message }, null, MessageDialogComponent, 'message-dialog');

    }

    public ngAfterViewInit() {
        this.dataSource.sort = this.sort
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    getImage(type) {
        return this.imageByType[type];
    }

    scroll(event: any) {
        if(this.resetSize == true){
            this.page = 1
            this.resetSize = false;
        }
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight && event.target.scrollTop !== 0) {
            this.page += 1
            this.flagpag.emit(true)
            this.getLogs.emit(this.page)
        }
    }

    public isActionColumnVisible(): boolean {
        if (!(this.envDetail && this.envDetail.environments)) {
            return false;
        }
        const environment = this.envDetail.environments.find(m => m.id.toString() === this.environmentId);
        if (!environment) {
            return false;
        }
        return !this.isHistory && this.dplModeType === 'ByTask' && !environment.isManaged && !environment.isRMSource;
    }

    private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }




    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
        this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }




    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
                }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/log-viewer-ang7/log-viewer-data/log-viewer-data.component.ts